// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

body {padding-bottom: 70px;}

.app-container {
    widtH: 80%;
    margin: auto;
}


:root {
  --theme: #cfe2ff;
  --theme-hover: #8db1f1;
  --woman-in-red: #D73334;
}

.btn, .navbar  {
    background-color: var(--theme)!important;
    border-color: var(--theme)!important;
    color: black;
}


.btn:hover {
    background-color: var(--theme-hover)!important;
    border-color: var(--theme-hover) !important;
    color: black!important;
}

input[type=checkbox]:checked {
    background-color: var(--theme-hover) !important;
    border-color: var(--theme-hover);
}
input[type='checkbox']:after {
    box-shadow: none !important;
}

option:checked {
    background: var(--theme);
}


.scrollable-table {
  max-height: 450px;
  overflow-y: scroll;
}

.fixed-button {
  position: sticky;
  bottom: 0;
  padding: 10px 0;
}

.woman-in-red-box {
    background-color: var(--woman-in-red);
    border: 2px solid var(--woman-in-red);
    padding-left: 5px;
    padding-right: 5px;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,MAAM,oBAAoB,CAAC;;AAE3B;IACI,UAAU;IACV,YAAY;AAChB;;;AAGA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,YAAY;AAChB;;;AAGA;IACI,8CAA8C;IAC9C,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,gCAAgC;AACpC;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".App {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nbody {padding-bottom: 70px;}\n\n.app-container {\n    widtH: 80%;\n    margin: auto;\n}\n\n\n:root {\n  --theme: #cfe2ff;\n  --theme-hover: #8db1f1;\n  --woman-in-red: #D73334;\n}\n\n.btn, .navbar  {\n    background-color: var(--theme)!important;\n    border-color: var(--theme)!important;\n    color: black;\n}\n\n\n.btn:hover {\n    background-color: var(--theme-hover)!important;\n    border-color: var(--theme-hover) !important;\n    color: black!important;\n}\n\ninput[type=checkbox]:checked {\n    background-color: var(--theme-hover) !important;\n    border-color: var(--theme-hover);\n}\ninput[type='checkbox']:after {\n    box-shadow: none !important;\n}\n\noption:checked {\n    background: var(--theme);\n}\n\n\n.scrollable-table {\n  max-height: 450px;\n  overflow-y: scroll;\n}\n\n.fixed-button {\n  position: sticky;\n  bottom: 0;\n  padding: 10px 0;\n}\n\n.woman-in-red-box {\n    background-color: var(--woman-in-red);\n    border: 2px solid var(--woman-in-red);\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
